<template>
    <div class="modal-content" ref="modalBox">
    </div>
</template>

<script>
import lottie from "lottie-web";

export default {
  props: {
    data: {
      type: Object,
      default: {}
    }
  },
  mounted() {
    this.loadAnimation();
  },
  methods: {
    loadAnimation() {
      this.saveAnimation = lottie.loadAnimation({
        container: this.$refs.modalBox, // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: this.data // the path to the animation json
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  /* Modal Content */

.modal-content {
  // z-index: 20;
  // width: 5%;
  display: flex;
  position: absolute;
  // top: 30%;
  // left: 45%;
}
</style>
